/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './toast.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../svg-icon/svg-icon.component.ngfactory';
import * as i3 from '../../../../app/shared/svg-icon/svg-icon.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../app/shared/toast/toast.component';
const styles_ToastComponent:any[] = [i0.styles];
export const RenderType_ToastComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_ToastComponent,data:{}});
function View_ToastComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'button',[['class',
      'no-style close-button']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.hide()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),
      i1.ɵeld(0,(null as any),(null as any),1,'svg-icon',[['name','close']],(null as any),
          (null as any),(null as any),i2.View_SvgIconComponent_0,i2.RenderType_SvgIconComponent)),
      i1.ɵdid(114688,(null as any),0,i3.SvgIconComponent,[i1.ElementRef,i1.Renderer2],
          {name:[0,'name']},(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        const currVal_0:any = 'close';
        _ck(_v,3,0,currVal_0);
      },(null as any));
}
export function View_ToastComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'div',[['class',
      'message']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['',''])),(_l()(),i1.ɵted((null as any),['\n\n'])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ToastComponent_1)),
      i1.ɵdid(16384,(null as any),0,i4.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i5.ToastComponent = _v.component;
    const currVal_1:any = _co.showCloseButton;
    _ck(_v,4,0,currVal_1);
  },(_ck,_v) => {
    var _co:i5.ToastComponent = _v.component;
    const currVal_0:any = _co.message;
    _ck(_v,1,0,currVal_0);
  });
}
export function View_ToastComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'toast',([] as any[]),
      (null as any),(null as any),(null as any),View_ToastComponent_0,RenderType_ToastComponent)),
      i1.ɵdid(49152,(null as any),0,i5.ToastComponent,[i1.ElementRef,i1.Renderer2],
          (null as any),(null as any))],(null as any),(null as any));
}
export const ToastComponentNgFactory:i1.ComponentFactory<i5.ToastComponent> = i1.ɵccf('toast',
    i5.ToastComponent,View_ToastComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3RvYXN0L3RvYXN0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC90b2FzdC90b2FzdC5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC90b2FzdC90b2FzdC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL3RvYXN0L3RvYXN0LmNvbXBvbmVudC50cy5Ub2FzdENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJtZXNzYWdlXCI+e3ttZXNzYWdlfX08L2Rpdj5cclxuXHJcbjxidXR0b24gY2xhc3M9XCJuby1zdHlsZSBjbG9zZS1idXR0b25cIiAqbmdJZj1cInNob3dDbG9zZUJ1dHRvblwiIChjbGljayk9XCJoaWRlKClcIj5cclxuICAgIDxzdmctaWNvbiBuYW1lPVwiY2xvc2VcIj48L3N2Zy1pY29uPlxyXG48L2J1dHRvbj4iLCI8dG9hc3Q+PC90b2FzdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDRUE7TUFBQTtJQUFBO0lBQUE7SUFBOEQ7TUFBQTtNQUFBO0lBQUE7SUFBOUQ7RUFBQSxnQ0FBK0UsMkNBQzNFO2FBQUE7VUFBQTthQUFBO1VBQUEsaUNBQWtDOztRQUF4QjtRQUFWLFdBQVUsU0FBVjs7OztvQkFISjtNQUFBO01BQXFCLHdDQUFpQjtNQUV0QzthQUFBO1VBQUE7O0lBQXNDO0lBQXRDLFdBQXNDLFNBQXRDOzs7SUFGcUI7SUFBQTs7OztvQkNBckI7TUFBQTthQUFBO1VBQUE7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/toast/toast.component.ngfactory.ts